import * as React from 'react';

const QuickRepliesBadge32 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 32 32", width: 32, height: 32, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "#C9F0EE",
    d: "M32 16c0 8.836-7.163 16-16 16S0 24.836 0 16 7.164 0 16 0s16 7.163 16 16"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "#007782",
    d: "M7.87 10.132c-.15.344-.233.716-.233 1.097v4.54c0 .417.335.711.749.656a.886.886 0 0 0 .749-.854v-4.39l5.92 4.91c.97.806 2.495.604 3.465-.457l6.308-6.9q.023.105.024.22v9.08c0 .564-.454 1.082-1.013 1.156L4.906 21.705a.886.886 0 0 0-.749.855c0 .417.336.71.75.656L23.84 20.7c1.386-.184 2.51-1.467 2.51-2.865v-9.08c0-1.4-1.125-2.385-2.512-2.202l-13.69 1.81c-.981.13-1.83.81-2.244 1.691l-.052.062zm2.218-.247.06-.01 13.34-1.764-6.001 6.566c-.392.428-1.007.51-1.399.185z"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "#007782",
    d: "M5.856 18.858c0-.417.336-.797.75-.847l3.315-.407a.65.65 0 0 1 .75.663.876.876 0 0 1-.75.848l-3.315.407a.652.652 0 0 1-.75-.664m5.111 5.092a.876.876 0 0 0-.75.848c0 .418.336.715.75.664l6.489-.797c.414-.05.75-.43.75-.847a.652.652 0 0 0-.75-.664z"
  }
));
QuickRepliesBadge32.Size = 32;
QuickRepliesBadge32.Title = "QuickRepliesBadge";

export { QuickRepliesBadge32 as default };
